import English from "./languages/english";
import French from "./languages/french";

export default Object.freeze({
  en: English,
  fr: French,
});
